export enum OrderStatus {
  PENDING = 'pending',
  PREPARING = 'preparing',
  ON_WAY = 'on_way',
  DELIVERED = 'delivered',
  REJECTED = 'rejected',
}
